import { ISmartTagRuntimeVO } from 'tag/ts/smart_tag/interfaces/ISmartTagRuntimeVO';
import { SmartTagRuntimeVO } from 'tag/ts/smart_tag/utilities/SmartTagRuntimeVO';

/**
 * @description Returns existing SmartTag RuntimeVO instance or creates a new one
 * @param {ISmartTagRuntimeVO} runtimeVO
 * @return {ISmartTagRuntimeVO}
 */
export const getSmartTagRuntimeVO = ( runtimeVO: ISmartTagRuntimeVO = window?.SmartTag?.runtimeVO || new SmartTagRuntimeVO() ): ISmartTagRuntimeVO | null => {
	return runtimeVO;
};